import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

let router = new Router({
  routes: [
    {
      path: '/',
      name: '',
      redirect: '/login',
      component: resolve => {
        require(['@/components/pages/login/Login.vue'], resolve)
      }
    },
    { // 登录页
      path: '/login',
      name: 'Login',
      component: resolve => {
        require(['@/components/pages/login/Login.vue'], resolve)
      }
    },
    { // 主内容组件
      path: '/mainContainer',
      name: 'MainContainer',
      redirect: '/home',
      component: resolve => {
        require(['@/components/pages/main/MainContainer.vue'], resolve)
      },
      children: [
        { // 首页/欢迎页
          path: '/home',
          name: 'Home',
          component: resolve => {
            require(['@/components/pages/home/Home.vue'], resolve)
          }
        },
        { // 栏目管理-栏目设置
          path: '/columnSet',
          name: 'ColumnSet',
          component: resolve => {
            require(['@/components/pages/column-manage/ColumnSet.vue'], resolve)
          }
        },
        { // 栏目管理-页面模块设置
          path: '/pageModuleSet',
          name: 'PageModuleSet',
          component: resolve => {
            require(['@/components/pages/column-manage/PageModuleSet.vue'], resolve)
          }
        },
        { // 栏目管理-页面模块设置-轮播模块-添加/编辑
          path: '/bannerEdit',
          name: 'BannerEdit',
          component: resolve => {
            require(['@/components/pages/column-manage/BannerEdit.vue'], resolve)
          }
        },
        { // 栏目管理-页面模块设置-分类模块-添加/编辑
          path: '/caseEdit',
          name: 'CaseEdit',
          component: resolve => {
            require(['@/components/pages/column-manage/CaseEdit.vue'], resolve)
          }
        },
        { // 栏目管理-政策扶持
          path: '/policySupport',
          name: 'PolicySupport',
          component: resolve => {
            require(['@/components/pages/column-manage/PolicySupport.vue'], resolve)
          }
        },
        { // 栏目管理-政策扶持-添加/编辑
          path: '/policySupportEdit',
          name: 'PolicySupportEdit',
          component: resolve => {
            require(['@/components/pages/column-manage/PolicySupportEdit.vue'], resolve)
          }
        },
        { // 产品管理-商品审核
          path: '/goodsAudit',
          name: 'GoodsAudit',
          component: resolve => {
            require(['@/components/pages/product-manage/GoodsAudit.vue'], resolve)
          }
        },
        { // 产品管理-商品列表
          path: '/goodsList',
          name: 'GoodsList',
          component: resolve => {
            require(['@/components/pages/product-manage/GoodsList.vue'], resolve)
          }
        },
        { // 产品管理-商品-添加、编辑、审核等操作
          path: '/goodsEdit',
          name: 'GoodsEdit',
          component: resolve => {
            require(['@/components/pages/product-manage/GoodsEdit.vue'], resolve)
          }
        },
        { // 产品管理-系统分类管理
          path: '/caseManage',
          name: 'CaseManage',
          component: resolve => {
            require(['@/components/pages/product-manage/CaseManage.vue'], resolve)
          }
        },
        { // 产品管理-服务商分类管理
          path: '/serviceCateManage',
          name: 'ServiceCateManage',
          component: resolve => {
            require(['@/components/pages/product-manage/ServiceCateManage.vue'], resolve)
          }
        },
        { // 服务商审核列表
          path: '/facilitatorAudit',
          name: 'FacilitatorAudit',
          component: resolve => {
            require(['@/components/pages/facilitator-manage/FacilitatorAudit.vue'], resolve)
          }
        },
        { // 服务商列表
          path: '/facilitatorList',
          name: 'FacilitatorManage',
          component: resolve => {
            require(['@/components/pages/facilitator-manage/FacilitatorManage.vue'], resolve)
          }
        },
        { // 服务商管理-添加/编辑/审核服务商
          path: '/facilitatorEdit',
          name: 'FacilitatorEdit',
          component: resolve => {
            require(['@/components/pages/facilitator-manage/FacilitatorEdit.vue'], resolve)
          }
        },
        { // 服务商管理-添加成功案例
          path: '/successfulCaseEdit',
          name: 'SuccessfulCaseEdit',
          component: resolve => {
            require(['@/components/pages/facilitator-manage/SuccessfulCaseEdit.vue'], resolve)
          }
        },
        { // 课程管理-课程审核
          path: '/courseAudit',
          name: 'CourseAudit',
          component: resolve => {
            require(['@/components/pages/course-manage/CourseAudit.vue'], resolve)
          }
        },
        { // 课程管理-课程列表
          path: '/courseList',
          name: 'CourseList',
          component: resolve => {
            require(['@/components/pages/course-manage/CourseList.vue'], resolve)
          }
        },
        { // 课程管理-课程列表-添加、编辑、审核
          path: '/courseEdit',
          name: 'CourseEdit',
          component: resolve => {
            require(['@/components/pages/course-manage/CourseEdit.vue'], resolve)
          }
        },
        { // 订单管理-订单列表
          path: '/orderList',
          name: 'OrderList',
          component: resolve => {
            require(['@/components/pages/order-manage/OrderList.vue'], resolve)
          }
        },
        { // 订单管理-售后订单
          path: '/afterSaleOrder',
          name: 'AfterSaleOrder',
          component: resolve => {
            require(['@/components/pages/order-manage/AfterSaleOrder.vue'], resolve)
          }
        },
        { // 订单管理-订单详情
          path: '/orderDetail',
          name: 'OrderDetail',
          component: resolve => {
            require(['@/components/pages/order-manage/OrderDetail.vue'], resolve)
          }
        },
        { // 订单管理-评价管理
          path: '/estimateManage',
          name: 'EstimateManage',
          component: resolve => {
            require(['@/components/pages/order-manage/EstimateManage.vue'], resolve)
          }
        },
        { // 委托开通-申请列表
          path: '/authorizeApplyList',
          name: 'AuthorizeApplyList',
          component: resolve => {
            require(['@/components/pages/authorize-open/AuthorizeApplyList.vue'], resolve)
          }
        },
        { // 委托开通-详情
          path: '/authorizeEdit',
          name: 'AuthorizeEdit',
          component: resolve => {
            require(['@/components/pages/authorize-open/AuthorizeEdit.vue'], resolve)
          }
        },
        { // 广告管理-广告审核
          path: '/advertisingAudit',
          name: 'AdvertisingAudit',
          component: resolve => {
            require(['@/components/pages/advertising-manage/AdvertisingAudit.vue'], resolve)
          }
        },
        { // 广告管理-广告列表
          path: '/advertisingList',
          name: 'AdvertisingList',
          component: resolve => {
            require(['@/components/pages/advertising-manage/AdvertisingList.vue'], resolve)
          }
        },
        { // 广告管理-广告列表-广告添加、编辑、查看、审核
          path: '/advertisingEdit',
          name: 'AdvertisingEdit',
          component: resolve => {
            require(['@/components/pages/advertising-manage/AdvertisingEdit.vue'], resolve)
          }
        },
        { // 会员列表
          path: '/memberList',
          name: 'MemberList',
          component: resolve => {
            require(['@/components/pages/member-list/MemberList.vue'], resolve)
          }
        },
        { // 会员列表-详情
          path: '/memberDetail',
          name: 'MemberDetail',
          component: resolve => {
            require(['@/components/pages/member-list/MemberDetail.vue'], resolve)
          }
        },
        { // 提现审核列表
          path: '/withdrawAudit',
          name: 'WithdrawAudit',
          component: resolve => {
            require(['@/components/pages/withdraw-audit/WithdrawAudit.vue'], resolve)
          }
        },
        { // 提现审核列表-详情
          path: '/withdrawAuditDetail',
          name: 'WithdrawAuditDetail',
          component: resolve => {
            require(['@/components/pages/withdraw-audit/WithdrawAuditDetail.vue'], resolve)
          }
        },
        { // 行业分类
          path: '/industryClass',
          name: 'IndustryClass',
          component: resolve => {
            require(['@/components/pages/industry-class/IndustryClass.vue'], resolve)
          }
        },
        { // 系统通知-通知类型
          path: '/noticeType',
          name: 'NoticeType',
          component: resolve => {
            require(['@/components/pages/system-notice/NoticeType.vue'], resolve)
          }
        },
        { // 系统通知-通知列表
          path: '/noticeList',
          name: 'NoticeList',
          component: resolve => {
            require(['@/components/pages/system-notice/NoticeList.vue'], resolve)
          }
        },
        { // 系统通知-通知列表-添加、编辑
          path: '/noticeEdit',
          name: 'NoticeEdit',
          component: resolve => {
            require(['@/components/pages/system-notice/NoticeEdit.vue'], resolve)
          }
        },
        { // 空白页
          path: '/pageNull',
          name: 'PageNull',
          component: resolve => {
            require(['@/components/pages/PageNull.vue'], resolve)
          }
        },
      ]
    }
  ]
});

// router.beforeEach((to, form, next) => {
//   let token = window.localStorage.getItem('token');
//   if(to.path === '/login') { 
//     if(token) {
//       return next({ path: '/home' });
//     }
//     return next();
//   }
//   if(token) {
//     return next();
//   } else {
//     // 没有登录还想去其他页面，不可能，滚去登录页
//     return next({ path: '/login' });
//   }
// });

export default router



// WEBPACK FOOTER //
// ./src/router/index.js